import React from 'react';
import { useApp } from '@backstage/core-plugin-api';
import { WikiImportPage } from './WikiImportPage';
import { useWikiImportEnabled } from './useWikiImportEnabled';

export const WikiImportRoute = () => {
  const { NotFoundErrorPage } = useApp().getComponents();
  const enabled = useWikiImportEnabled();
  return enabled ? <WikiImportPage /> : <NotFoundErrorPage />;
};
